export default __webpack_public_path__ + "static/media/visa.03d9df92.svg";